import React from "react";
import "./sectionDevelop.scss";

//Imagens:
import ImgSectionDevelop from "../../../../assets/developAndIntegrate/sectionDevelop.png";
import { useTranslation } from "react-i18next";

function SectionDevelop() {
  const { t } = useTranslation()

  return (
    <div className="container-section-develop">
      <div className="img-section-develop">
        <img src={ImgSectionDevelop} alt="" />
      </div>
      <div className="texts-section-develop">
        <h1>{t("suport.title")}</h1>
        <p>{t("suport.section_text")}</p>
        <a href="/form">
          <button id="btn-section-develop">
            {t("buttons.demo_btn_alternative_text_1")}
          </button>
        </a>
      </div>
    </div>
  );
}

export default SectionDevelop;
